export {}; // TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from CopilotChatProps.
// & Required<Pick<CopilotChatProps, 'propName'>>
//# sourceMappingURL=CopilotChat.types.js.map